import React, { useState, useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import { useCookies } from 'react-cookie';
import { 
    Flex, Box, Heading, FormControl, FormLabel, Input, Button, ButtonGroup, Text, CircularProgress, CircularProgressLabel,
    InputGroup, InputRightElement, Icon, IconButton,
    Stack, HStack, Image, Wrap, WrapItem, Center,
    Grid, GridItem, VStack, Spacer, Divider, Select,
    Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalCloseButton, ModalFooter, useDisclosure,
    Textarea, useToast,
    List, ListItem, ListIcon, Link
} from '@chakra-ui/react';
import { MdSave, MdCheckCircle, MdClose, MdDownload, MdPictureAsPdf, MdAddCircleOutline, MdDeleteForever, MdQrCode} from 'react-icons/md';
import arrayMutators from 'final-form-arrays';
import { Form, Field } from 'react-final-form';
import { FieldArray } from 'react-final-form-arrays';
import { SUCCESS_STATUS, FAILED_STATUS, PATIENT_RESULT_TYPES, FOOD_AVOIDS, ERROR_CODES } from '../../../constants';

import {Select as Select2} from 'chakra-react-select';

import axios from 'axios';

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.module.css';

import { apiLoadListDoctor } from '../../../redux/apis/DoctorApis';
import { apiLoadAPatientResult, apiCreateNewPatientResult, apiUpdateAPatientResult, apiExportMedicineToPDF } from '../../../redux/apis/PatientResultApis';
import { apiLoadASystemSettingByCompanyId }  from '../../../redux/apis/SystemSettingApis';
import { clearAPatientResultDetail, clearPatientResultActionStatus, clearMedicineToPDF } from "../../../redux/actions"

import { 
    getASystemSetting, getDoctorList, getPatientResultList, getAPatientResult, 
    getPatientResultActionStatus, getPatientResultActionMsg, getMedicineRemotePDF 
} from '../../../redux/selectors';

import DropZoneWithAnyFile from '../../../components/DropZoneWithAnyFile';
import ShowQRCodeModal from './ShowQRCodeModal';

function AddEditPatientResultModal({ 
    initialRef, isOpen, onClose, patientResultId, patientResultActionStatus, patientResultActionMsg,
    doctorList, patientDetail, patientResultList, patientResultDetail, systemSettingDetail, remotePDF,
    apiLoadAPatientResult, apiCreateNewPatientResult, apiUpdateAPatientResult,
    apiExportMedicineToPDF, clearAPatientResultDetail, clearPatientResultActionStatus, clearMedicineToPDF,
    apiLoadASystemSettingByCompanyId, apiLoadListDoctor, onFinished
}) {
    const [ cookies ] = useCookies(["loginCookie", "selectedClinic"]);
    const [ selectedPatientResultTypes, setSelectedPatientResultTypes ] = useState([]);
    const [ patientResultTypeList, setPatientResultTypeList ] = useState([]);
    const [ foodAvoidList, setFoodAvoidList ] = useState([]);
    const [ fileResults, setFileResults ] = useState([]);
    const [ isAddNewPatientResult, setIsAddNewPatientResult ] = useState(false);
    const [ isProcessingExportFile, setIsProcessingExportFile ] = useState(false);
    const [ isProcessing, setIsProcessing ] = useState(false);

    const toast = useToast();
    const mounted = useRef();
    const modalShowQRCode = useDisclosure();

    useEffect(() => {
        if(!mounted.current) {
            apiLoadASystemSettingByCompanyId({ company_id : cookies?.loginCookie?.data?.company_id });
            apiLoadListDoctor({ company_id: cookies?.loginCookie?.data?.company_id, order_by: "name", order_dir: "ASC" });

            if(patientResultId) {
                apiLoadAPatientResult({ id: patientResultId });
            }

            mounted.current = true;
        } 
    });

    useEffect(() => {
        if(isAddNewPatientResult) {
            if(patientResultList.length > 0) {
                apiLoadAPatientResult({ id: patientResultList[0]?.id });
            }
            setIsAddNewPatientResult(false);
        }
        setIsProcessing(false);
    }, [patientResultList]);

    useEffect(() => {
        if(patientResultDetail && patientResultDetail.results) {
            const _selectedPatientResultTypes = Object.keys(patientResultDetail.results).map(key => {
                let findPatienResultType = systemSettingDetail?.patient_result_types?.find(item => item.type === key);

                return {
                    label: key, value: key, size: findPatienResultType?.size
                }
            })
            
            setSelectedPatientResultTypes(_selectedPatientResultTypes);
        }
    }, [patientResultDetail]);

    useEffect(() => {
        const _patientResultTypeList = [];

        (systemSettingDetail?.patient_result_types ? systemSettingDetail?.patient_result_types : PATIENT_RESULT_TYPES).map(item => {
            _patientResultTypeList.push({
                label: item.type,
                value: item.type,
                size: item.size
            })
        })

        setPatientResultTypeList(_patientResultTypeList);

        const _foodAvoidList = [];

        (systemSettingDetail?.food_avoids ? systemSettingDetail?.food_avoids : FOOD_AVOIDS).map(item => {
            _foodAvoidList.push({
                label: item.value,
                value: item.value
            })
        });

        setFoodAvoidList(_foodAvoidList);
    }, [systemSettingDetail])

    useEffect(() => {
        let blobPDF, pdfFileURL;

        if (remotePDF){
            blobPDF = new Blob([remotePDF], {type: 'application/pdf'});
            //Build a URL from the file
            pdfFileURL = window.URL.createObjectURL(blobPDF);
            // //Open the URL on new Window
            window.open(pdfFileURL, '_blank');

            clearMedicineToPDF();
        }
        setIsProcessingExportFile(false);
    }, [remotePDF])

    useEffect(() => {
        if(patientResultActionStatus === SUCCESS_STATUS) {
            toast({
                description: patientResultActionMsg,
                status: "success",
                duration: 3000,
                isClosable: true,
                position: "bottom-right"
            })
            clearPatientResultActionStatus();
        } 
        else if(patientResultActionStatus === FAILED_STATUS) {
            toast({
                description: "Thao tác của bạn không thành công!",
                status: "error",
                duration: 3000,
                isClosable: true,
                position: "bottom-right"
            })
            clearPatientResultActionStatus();
        }
    }, [patientResultActionStatus]);

    const validate = (values) => {
        const errors = {};

        if(!values.doctor_id) {
            errors.doctor_id = "Required";
        }
        if(!values.date_return) {
            errors.date_return = "Required";
        }

        // fileResults?.length > 0 && fileResults.map((file, idx) => {
        //     const isGt10Mb = file.size/(1024*1024) > 10
        //     if(isGt10Mb) {
        //         errors.files = "Required";
        //     }
        // })

        return errors;
    }

    const onSubmit = async(values, form) => {
        // First, we will update files and get response url to create new patient results
        setIsProcessing(true);
        try
        {
            let uploadedFileResults = [];
            let isUploadFileError = false;

            await Promise.all(
                fileResults.map(async(file) => {
                    let data = new FormData();
                    data.append('uri', file);
        
                    let res = await axios.post(`${process.env.REACT_APP_API_ENDPOINT_URL}/upload?subPath=patient_results`, data, { 
                        headers: { "Content-Type": "multipart/form-data" },
                        auth: {
                            username: process.env.REACT_APP_BASIC_AUTH_USERNAME,
                            password: process.env.REACT_APP_BASIC_AUTH_PASSWORD
                        }
                    });

                    if(res.data?.status === 0) {
                        toast({
                            id: "patient-result-modal",
                            title: "Lỗi",
                            description: res.data.error,
                            status: "error",
                            duration: 3000,
                            isClosable: true,
                            position: "bottom-right"
                        })
                        isUploadFileError = true
                    } else if(res.data?.status === 200) {
                        uploadedFileResults.push(res.data.fileName);
                    }
                })
            );

            if(isUploadFileError) return;

            if(patientResultDetail && patientResultDetail.id) {
                apiUpdateAPatientResult({ 
                    id: patientResultDetail.id, 
                    payload: {
                        ...values,
                        file_results: [
                            ...patientResultDetail.file_results,
                            ...uploadedFileResults
                        ],
                        user_id: cookies?.loginCookie?.data?.id,
                    } 
                });
            } else {
                setIsAddNewPatientResult(true);
                apiCreateNewPatientResult({ 
                    ...values,
                    company_id: cookies?.loginCookie?.data?.company_id,
                    patient_id: patientDetail.id,
                    file_results: uploadedFileResults,
                    user_id: cookies?.loginCookie?.data?.id,  
                });
            }

            setFileResults([]);
            if(onFinished) onFinished();
        }
        catch(error) {
            if(error?.code) {
                toast({
                    description: `${ERROR_CODES[error?.code]} (${error?.code})`,
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                    position: "bottom-right"
                });
            }
        }
    }

    const handleExportMedicineToPDF = () => {
        setIsProcessingExportFile(true);

        setTimeout(() => {
            apiExportMedicineToPDF({
                payload: {
                    patient_result_id: patientResultDetail.id,
                    pageId: "medicine-sheet",
                    company_id: cookies?.loginCookie?.data?.company_id,
                    user_id: cookies?.loginCookie?.data?.id,  
                }
            })
        }, 500);
    }

    return (
        <Modal initialFocusRef={initialRef} isOpen={isOpen} 
            onClose={() => { 
                clearAPatientResultDetail();
                onClose();
            }} 
            closeOnOverlayClick={false} 
            size="4xl"
        >
            <ModalOverlay />
            <Form
                onSubmit={onSubmit}
                initialValues={{
                    ...patientResultDetail,
                    date_return: patientResultDetail?.date_return ? new Date(patientResultDetail?.date_return) : new Date(),
                }}
                mutators={{
                    ...arrayMutators
                }}
                keepDirtyOnReinitialize
                validate={validate}
                render={({ handleSubmit, form: { mutators: {push, pop, remove}, change }, submitting, pristine, valid, values, dirty }) => {
                    return (
                        <React.Fragment>
                            <form onSubmit={handleSubmit}>
                                <ModalContent>
                                    <ModalHeader>
                                        {patientResultDetail?.id ? "CẬP NHẬP" : "NHẬP"} KẾT QUẢ KHÁM
                                    </ModalHeader>
                                    <ModalCloseButton />

                                    <ModalBody pb={6}>
                                        <Flex flexDirection="column">
                                            <Box width="100%" borderWidth="1px" borderRadius={8} px={2} boxShadow="md">
                                                <Text as="u" fontWeight="600">THÔNG TIN BỆNH NHÂN</Text>
                                                
                                                <Flex flexDirection={{ base: "column", md: "row", lg: "row" }} flexWrap="wrap" justifyContent="flex-start" gap={1}>
                                                    <HStack mr={2}>
                                                        <Text>Bệnh nhân:</Text>
                                                        <Text color="orange.500" fontWeight="700">{patientDetail?.name}</Text>
                                                    </HStack>

                                                    <HStack mr={2}>
                                                        <Text>Năm sinh:</Text>
                                                        <Text fontWeight="700">{ patientDetail?.yearOfBirth }</Text>
                                                    </HStack>

                                                    <HStack mr={2}>
                                                        <Text>Giới tính:</Text>
                                                        <Text fontWeight="700">{ patientDetail?.gender }</Text>
                                                    </HStack>

                                                    <HStack mr={2}>
                                                        <Text>Địa chỉ:</Text>
                                                        <Text fontWeight="700">{ patientDetail?.address }</Text>
                                                    </HStack>
                                                </Flex>
                                            </Box>

                                            <Box width="100%" borderWidth="1px" borderRadius={8} px={2} py={2} boxShadow="md">
                                                <Text as="u" fontWeight="600">THÔNG TIN BÁC SỸ KHÁM</Text>

                                                <Flex flexDirection={{ base: "column", md: "row", lg: "row" }} align="center" justifyContent="flex-start" gap={4}>
                                                    <Field name="doctor_id">
                                                        {({ input, meta }) => (
                                                            <FormControl isRequired maxW="300px">
                                                                <FormLabel>Bác sỹ khám:</FormLabel>
                                                                <Select {...input} placeholder='Chọn bác sỹ khám'>
                                                                    {
                                                                        doctorList && doctorList.map(item => (
                                                                            <React.Fragment key={item.id}>
                                                                                <option value={item.id}>{item.name}</option>
                                                                            </React.Fragment>
                                                                        ))
                                                                    }
                                                                </Select>
                                                            </FormControl>
                                                        )}
                                                    </Field>

                                                    <Field name="date_return">
                                                        {({ input, meta }) => (
                                                            <FormControl isRequired>
                                                                <FormLabel>Ngày khám:</FormLabel>
                                                                <DatePicker {...input} 
                                                                    dateFormat="dd/MM/yyyy" 
                                                                    selected={input.value}
                                                                    showIcon
                                                                    className='date-picker'
                                                                    maxW="200px"
                                                                />
                                                            </FormControl>
                                                        )}
                                                    </Field>
                                                </Flex>
                                            </Box>
                                        </Flex>
                                
                                        
                                        <Box borderWidth="1px" borderRadius={8} px={2} py={2} mt={2} boxShadow="md">
                                            <Text as="u" fontWeight="600">NHẬP KẾT QUẢ</Text>
                                            <FormControl maxW="500px">
                                                <FormLabel>Chọn loại kết quả khám:</FormLabel>
                                                <Select2
                                                    isMulti
                                                    placeholder="Chọn loại kết quả khám"
                                                    options={patientResultTypeList}
                                                    value={selectedPatientResultTypes}
                                                    closeMenuOnSelect={false}
                                                    onChange={
                                                        (newValue) => {
                                                            const newResults = patientResultDetail?.results;
                                                            let isDeleted = false;

                                                            if(patientResultDetail?.results) {
                                                                Object.keys(patientResultDetail.results).map(key => {
                                                                    const idx = newValue.findIndex(item => item.label === key);
                                                                    if(idx === -1) {
                                                                        newResults[key] = "";
                                                                        delete newResults[key];
                                                                        isDeleted = true;
                                                                    }
                                                                })
                                                            }

                                                            // update if deleted
                                                            if(isDeleted) {
                                                                change("results", newResults);
                                                            }
                                                            setSelectedPatientResultTypes(newValue);
                                                        }
                                                    }
                                                />
                                            </FormControl>

                                            <Flex flexDirection="row" flexWrap="wrap" gap={1}>
                                                {
                                                    selectedPatientResultTypes.map((item, idx) => {
                                                        return (
                                                            // <GridItem key={`results-${idx}`}> 
                                                                <Field key={`results-${idx}`} name={`results.${item.value}`}>
                                                                    {({ input, meta }) => (
                                                                        <FormControl w={{ base: "100%", md: "33%", lg: "33%" }}>
                                                                            <FormLabel >{item.value}</FormLabel>
                                                                            <Textarea {...input} 
                                                                                rows={item.size === "VERY_LARGE" ? 5 : (item.size === "LARGE" ? 3 : 1)} 
                                                                                placeholder=''
                                                                            />
                                                                        </FormControl>
                                                                    )}
                                                                </Field>
                                                            // </GridItem> 
                                                        )
                                                    })
                                                }
                                            </Flex>

                                            {/* <Grid templateColumns='repeat(3, 1fr)' gap={1} mt={2}>
                                                {
                                                    selectedPatientResultTypes.map((item, idx) => {
                                                        return (
                                                            <GridItem key={`results-${idx}`}> 
                                                                <Field name={`results.${item.value}`}>
                                                                    {({ input, meta }) => (
                                                                        <FormControl >
                                                                            <FormLabel >{item.value}</FormLabel>
                                                                            <Textarea {...input} 
                                                                                rows={item.size === "VERY_LARGE" ? 5 : (item.size === "LARGE" ? 3 : 1)} 
                                                                                placeholder=''
                                                                            />
                                                                        </FormControl>
                                                                    )}
                                                                </Field>
                                                            </GridItem> 
                                                        )
                                                    })
                                                }
                                            </Grid> */}
                                        </Box>

                                        <Box borderWidth="1px" borderRadius={8} px={2} py={2} mt={2} boxShadow="md">
                                            <Flex flexDirection={{ base: "column", md: "row", lg: "row" }} justifyContent="space-between">
                                                <Text as="u" fontWeight="600">NHẬP ĐƠN THUỐC</Text>
                                                <Button colorScheme="blue" _hover={{ bg: "#7986cb"}}
                                                    onClick={() => push('medicine_results', {})}
                                                >
                                                    <Icon boxSize={6} as={MdAddCircleOutline} marginRight="4px" />   
                                                    <Text fontWeight="400">Thêm Đơn thuốc</Text>
                                                </Button>
                                            </Flex>

                                            <Grid templateColumns="repeat(1, 1fr)">
                                                <FieldArray name="medicine_results">
                                                    {
                                                        ({ fields }) => fields.map((name, idx) => {
                                                            return (
                                                                <Flex flexDirection={{ base: "column", md: "row", lg: "row" }} 
                                                                    key={name} mr={2} mt={2} borderBottomWidth="1px" py={2} gap={1}
                                                                >
                                                                    <Field name={`${name}.medicine_name`}>
                                                                        {({ input, meta }) => (
                                                                            <FormControl minW="30%">
                                                                                <FormLabel fontWeight="700">Thuốc:</FormLabel>
                                                                                <Input {...input} type='text' placeholder='' />
                                                                            </FormControl>
                                                                        )}
                                                                    </Field>
                                                                    <Field name={`${name}.count`}>
                                                                        {({ input, meta }) => (
                                                                            <FormControl>
                                                                                <FormLabel fontWeight="700">Số lượng:</FormLabel>
                                                                                <Input {...input} type='number' placeholder='' />
                                                                            </FormControl>
                                                                        )}
                                                                    </Field>
                                                                    <Field name={`${name}.drink_morning`}>
                                                                        {({ input, meta }) => (
                                                                            <FormControl>
                                                                                <FormLabel fontWeight="700">Sáng:</FormLabel>
                                                                                <Input {...input} type='number' placeholder='' />
                                                                            </FormControl>
                                                                        )}
                                                                    </Field>
                                                                    <Field name={`${name}.drink_afternoon`}>
                                                                        {({ input, meta }) => (
                                                                            <FormControl>
                                                                                <FormLabel fontWeight="700">Chiều:</FormLabel>
                                                                                <Input {...input} type='number' placeholder='' />
                                                                            </FormControl>
                                                                        )}
                                                                    </Field>
                                                                    <Field name={`${name}.drink_night`}>
                                                                        {({ input, meta }) => (
                                                                            <FormControl>
                                                                                <FormLabel fontWeight="700">Tối:</FormLabel>
                                                                                <HStack>
                                                                                    <Input {...input} type='number' placeholder='' />
                                                                                    <IconButton
                                                                                        variant="outline"
                                                                                        colorScheme='red'
                                                                                        title='Xoá'
                                                                                        icon={<MdDeleteForever />}
                                                                                        onClick={() => remove('medicine_results', idx)}
                                                                                    />
                                                                                </HStack>
                                                                            </FormControl>
                                                                        )}
                                                                    </Field>
                                                                </Flex>
                                                            )
                                                        })
                                                    }
                                                </FieldArray>
                                            </Grid>
                                            
                                            <Center>
                                                <FieldArray name="medicine_results">
                                                    {
                                                        ({ fields }) => {
                                                            return (
                                                                !fields.value && <Text as="i" color="#757575">Nhấn "Thêm Đơn thuốc" để thêm đơn thuốc cho bệnh nhân</Text>
                                                            )
                                                        }
                                                    }
                                                </FieldArray>
                                            </Center>

                                            <Divider mt={2}/>

                                            <Flex flexDirection={{ base: "column", md: "row", lg: "row" }} gap={4}>
                                                <Field name='cure_day'>
                                                    {({ input, meta }) => (
                                                        <FormControl maxW="200px">
                                                            <FormLabel fontWeight="700">Số ngày điều trị:</FormLabel>
                                                            <Input {...input} type='number' placeholder='Nhập số ngày' />
                                                        </FormControl>
                                                    )}
                                                </Field>
                                                <Field name='food_avoid'>
                                                    {({ input, meta }) => (
                                                        <FormControl maxW="400px">
                                                            <FormLabel fontWeight="700">Kiêng:</FormLabel>    
                                                            <Select2 
                                                                {...input} 
                                                                isMulti
                                                                placeholder="Chọn đồ kiêng"
                                                                options={foodAvoidList}
                                                                closeMenuOnSelect={false}
                                                            />
                                                        </FormControl>
                                                    )}
                                                </Field>
                                            </Flex>
                                            
                                            <FormControl mt={4}>
                                                <FormLabel fontWeight="700">UPLOAD FILE KẾT QUẢ</FormLabel>
                                                <Box mt={2}>
                                                    <DropZoneWithAnyFile subPath={`patient_results`} note="(lưu ý chỉ nhập file có dung lượng < 10Mb)"
                                                        fileResults={fileResults} 
                                                        setFileResults={(files) => {
                                                            setFileResults(files);
                                                        }}
                                                    />

                                                    {
                                                        patientResultDetail?.file_results?.length > 0 &&
                                                        <React.Fragment>
                                                            <Text as="u" fontSize="16px" fontWeight="700">Files hiện tại:</Text>
                                                            <List spacing={2}>
                                                                {
                                                                    patientResultDetail.file_results.map((file, idx) => (
                                                                        <ListItem key={`file-${idx}`}>
                                                                            <HStack>
                                                                                <ListIcon as={MdCheckCircle} color="green.500" />
                                                                                <Link href={`${process.env.REACT_APP_UPLOADS_ENDPOINT_URL}/patient_results/${file}`} target="_blank" color="#1565c0">
                                                                                    {file}
                                                                                </Link>
                                                                            </HStack>
                                                                        </ListItem>
                                                                    ))                                                        
                                                                }
                                                            </List>
                                                        </React.Fragment>
                                                    }

                                                    {
                                                        fileResults?.length > 0 && <Text as="u" fontSize="16px" fontWeight="700">Files mới:</Text>
                                                    }
                                                    <List>
                                                        {
                                                            fileResults?.length > 0 && fileResults.map((file, idx) => {
                                                                //const isGt10Mb = file.size/(1024*1024) > 10

                                                                return (
                                                                    <ListItem key={`file-${idx}`}>
                                                                        <HStack mt={1}>
                                                                            <ListIcon as={MdCheckCircle} color="green.500" />
                                                                            <Text color="orange.500">
                                                                            {/* <Text color={isGt10Mb ? "red.400" : "orange.500"}> */}
                                                                                {`${idx + 1 } - ${file?.name} (${(file.size/1024).toFixed(2)} KB)`}
                                                                            </Text>
                                                                            <IconButton
                                                                                size="xs"
                                                                                variant="outline"
                                                                                title='Xoá'
                                                                                colorScheme="red"
                                                                                icon={<MdClose />}
                                                                                onClick={() => {
                                                                                    let updateFR = fileResults.filter(item => item.name !== file.name);
                                                                                    setFileResults(updateFR);
                                                                                }}
                                                                            />
                                                                        </HStack>
                                                                    </ListItem>
                                                                )
                                                            })
                                                        }
                                                    </List>
                                                </Box>
                                            </FormControl>
                                        </Box>
                                    </ModalBody>
                                
                                    <ModalFooter>
                                        <Flex flexDirection={{ base: "column", md: "row", lg: "row" }} justifyContent={{ base: "flex-start", md: "flex-end", lg: "flex-end" }} gap={2} width="100%">
                                            {
                                                patientResultDetail?.id &&
                                                <HStack>
                                                    <Button colorScheme="teal" onClick={() => modalShowQRCode.onOpen()}>
                                                        <Icon boxSize={6} as={MdQrCode} marginRight="8px"/> 
                                                        <Text>QR Code</Text>
                                                    </Button>
                                                    <Button colorScheme="purple" 
                                                        isLoading={isProcessingExportFile}
                                                        loadingText="Đang xuất file"
                                                        onClick={handleExportMedicineToPDF}
                                                    >
                                                        <Icon boxSize={6} as={MdPictureAsPdf} marginRight="8px"/> 
                                                        <Text>Xuất File</Text>
                                                    </Button>
                                               </HStack>
                                            }

                                            <Button colorScheme='green' type='submit' 
                                                isDisabled={!valid}
                                                isLoading={isProcessing}
                                                loadingText="Đang lưu"
                                            >
                                                <Icon boxSize={6} as={MdSave} marginRight="8px"/> 
                                                <Text >Lưu</Text>
                                            </Button>
                                        </Flex>
                                    </ModalFooter>
                                </ModalContent>
                            </form>
                        </React.Fragment>
                    )
                }}
            />
            {
                modalShowQRCode.isOpen &&
                <ShowQRCodeModal 
                    initialRef={initialRef} isOpen={modalShowQRCode.isOpen} onClose={modalShowQRCode.onClose}
                    patientDetail={patientDetail} patientResultDetail={patientResultDetail}
                />
            }
        </Modal>

    )
}

const mapStateToProps = (state) => {
    const systemSettingDetail =     getASystemSetting(state);
    const doctorList =              getDoctorList(state);
    const patientResultList =       getPatientResultList(state);
    const patientResultDetail =     getAPatientResult(state);
    const patientResultActionStatus =   getPatientResultActionStatus(state);
    const patientResultActionMsg    =   getPatientResultActionMsg(state);
    const remotePDF                 =   getMedicineRemotePDF(state);

    return { systemSettingDetail, doctorList, patientResultList, patientResultDetail, patientResultActionStatus, patientResultActionMsg, remotePDF };
}

const mapDispatchToProps = (dispatch) => ({
    apiLoadASystemSettingByCompanyId:   payload => dispatch(apiLoadASystemSettingByCompanyId(payload)),
    apiLoadListDoctor:                  payload => dispatch(apiLoadListDoctor(payload)),
    apiLoadAPatientResult:              payload => dispatch(apiLoadAPatientResult(payload)),
    apiCreateNewPatientResult:          payload => dispatch(apiCreateNewPatientResult(payload)),
    apiUpdateAPatientResult:            payload => dispatch(apiUpdateAPatientResult(payload)),
    apiExportMedicineToPDF:             payload => dispatch(apiExportMedicineToPDF(payload)),

    clearAPatientResultDetail:          payload => dispatch(clearAPatientResultDetail(payload)),
    clearPatientResultActionStatus:     payload => dispatch(clearPatientResultActionStatus(payload)),
    clearMedicineToPDF:                 payload => dispatch(clearMedicineToPDF(payload)),
})

export default connect(mapStateToProps, mapDispatchToProps)(AddEditPatientResultModal);